import {CLEAR_BETTING_SHIFT, LIST_BANKS, LIST_LOTTERY, LIST_MEMBER, LIST_PAGES, LIST_SHIFTS} from "./types";
import {LIST_SHIFTS_CONFIG} from "../gameconfig/types";

const init = {
    pages: [],
    shifts: [],
    shiftsConfig: [],
    members: [],
    banks: [],
    lotteries: [],

};

export default (state = init, {type, payload}) => {
    switch (type) {

        case LIST_PAGES:
            return {
                ...state,
                pages: payload,
            };
        case LIST_MEMBER:
            return {
                ...state,
                members: payload,
            };
        case LIST_SHIFTS:
            return {
                ...state,
                shifts: payload,
            };
        case LIST_SHIFTS_CONFIG:
            return {
                ...state,
                shiftsConfig: payload,
            };
        case CLEAR_BETTING_SHIFT:
            return {
                ...state,
                shifts: [],
            };
        case LIST_BANKS:
            return {
                ...state,
                banks: payload,
            };
        case LIST_LOTTERY:
            return {
                ...state,
                lotteries: payload,
            };

        default:
            return state;
    }
}


